import { render, staticRenderFns } from "./SchedulesTable.vue?vue&type=template&id=552be61b"
import script from "./SchedulesTable.vue?vue&type=script&lang=js"
export * from "./SchedulesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports